module.exports = __webpack_public_path__ + "img/mood.92c37392.jpg";